export const GET_ROTATE_STATUS = "GET_ROTATE_STATUS";
export const SET_ROTATE_STATUS = "SET_ROTATE_STATUS";
